import { requestState } from '../type/type';
import { createSlice } from '@reduxjs/toolkit'
import { fetchAllImages, uploadImage, deleteImage, updateImage } from './galleryActions';

const allImagesState = {
  images: [],
  error: "",
  status: requestState.idle
}

const singleImageState = {
  image: [],
  error: "",
  status: requestState.idle,
  uploadProgress: 0
}

const galleryState = {
  images: allImagesState,
  image: singleImageState,
}


const gallerySlice = createSlice({
  name: 'gallery',
  initialState: galleryState,
  extraReducers: builder => {
    builder.addCase(fetchAllImages.pending, state => {
      state.images.status = requestState.loading
    })
    builder.addCase(fetchAllImages.fulfilled, (state, action) => {
      state.images.status = requestState.success
      state.images.images = action.payload
      state.images.error = ''
    })
    builder.addCase(fetchAllImages.rejected, (state, action) => {
      state.images.status = requestState.failed
      state.images.images = []
      state.images.error = action.error.message
    })
    builder.addCase(uploadImage.pending, state => {
      state.image.status = requestState.loading
    })
    builder.addCase(uploadImage.fulfilled, (state, action) => {
      state.image.status = requestState.success
      state.image.image = action.payload
      state.image.error = ''
    })
    builder.addCase(uploadImage.rejected, (state, action) => {
      state.image.status = requestState.failed
      state.image.error = action.error.message
    })
    builder.addCase(deleteImage.pending, state => {
      state.image.status = requestState.loading
    })
    builder.addCase(deleteImage.fulfilled, (state, action) => {
      state.image.status = requestState.success
      // Remove deleted image from the images array
      if (state.images.images.results) {
        state.images.images.results = state.images.images.results.filter(
          img => img.id !== parseInt(action.payload.data.id)
        )
        state.images.images.count = state.images.images.count - 1
      }
      state.image.error = ''
    })
    builder.addCase(deleteImage.rejected, (state, action) => {
      state.image.status = requestState.failed
      state.image.error = action.error.message
    })
    builder.addCase(updateImage.pending, state => {
      state.image.status = requestState.loading
    })
    builder.addCase(updateImage.fulfilled, (state, action) => {
      state.image.status = requestState.success
      // Update the image in the images array
      if (state.images.images.results) {
        const index = state.images.images.results.findIndex(
          img => img.id === action.payload.data.id
        )
        if (index !== -1) {
          state.images.images.results[index] = action.payload.data
        }
      }
      state.image.error = ''
    })
    builder.addCase(updateImage.rejected, (state, action) => {
      state.image.status = requestState.failed
      state.image.error = action.error.message
    })
  
  }
})

  
export const galleryReducer = gallerySlice.reducer